import { observer } from 'mobx-react-lite';
import { LazyModule } from './lazy-module';

export const Metodej = observer(function Metodej() {
  return <LazyModule moduleCode="metodej" waitForRootStore />;
});
